import { z } from 'zod';

export const ExerciseParticipantSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1),
    unit: z.string().optional(),
    role: z.string().optional(),
    responsibilities: z.string().optional(),
    contact: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateExerciseParticipantSchema = ExerciseParticipantSchema.omit({ id: true });
export const UpdateExerciseParticipantSchema = ExerciseParticipantSchema.partial();
